import React, { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { hideOverlay, setSelectedThemeUid  } from '../actions';
import commonUtil from '../../../../../utils/commonUtil';


const ColorPickerOverlay = ({ isColorPickerOpen, hideOverlay, themes, setSelectedThemeUid, onValueUpdate }) => {


  if (!isColorPickerOpen) {
    document.body.classList.remove('body-no-scroll');
    return null;
  } 

  if(isColorPickerOpen){
    document.body.classList.add("body-no-scroll");
  }

  const handleThemeSelect = (uid) => {
    setSelectedThemeUid(uid);
    hideOverlay(); // optional: close overlay

    if(onValueUpdate){
      onValueUpdate("eventTheme",uid);
    }
  };


  return (
    <div className="modal-overlay">
      <div className="modal-content-event">
        <div className="evnt-modal-header">
          <h4 className="modal-title">Elige los colores que reflejen tu estilo</h4>
          <button className="close-button" onClick={hideOverlay} aria-label="Cerrar modal">
            <img src={commonUtil.getAssetURL() + '/images/close.svg'} alt="" className="icon_vozcliente" />
          </button>
        </div>
        <div className="evnt_modal_body color-picker-wrapper" onClick={(e) => e.stopPropagation()}>
         <div className="row color-picker-row">
            <ul className="color-picker-list-group">
              {themes.map((theme) => (
                <li key={theme.uid} onClick={() => handleThemeSelect(theme.uid)}>
                  <span style={{ backgroundColor: theme.color_50 }}></span>
                  <span style={{ backgroundColor: theme.color_400 }}></span>
                  <span style={{ backgroundColor: theme.color_600 }}></span>
                  <span style={{ backgroundColor: theme.color_900 }}></span>
                  <span>{theme.title}{(theme.isDefault) && ' (default)'}</span>
                </li>
              ))}
            </ul>
         </div>

        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    isColorPickerOpen: state?.createEvent?.isColorPickerOpen ?? false,
    themes: state?.createEvent?.themeData ?? [],
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ hideOverlay, setSelectedThemeUid }, dispatch);
};


export default connect(mapStateToProps, mapDispatchToProps)(ColorPickerOverlay);


